import { __awaiter } from "tslib";
import get from 'lodash/get';
export default function getCurrentUserId() {
    return __awaiter(this, void 0, void 0, function* () {
        // read from user level context
        return parseInt(get(window, '_ulc.user.id', '0'), 10);
    });
}
